import { css } from "@emotion/react"

import { fontsCP, colorsCP } from "../../Tokens"

export const iqAccordion = css`
.iq-accordion {
	font-family: ${fontsCP["font-primary"]["font-family"]};
	color: ${colorsCP["neutral-50"]};

  &__item {
    border-bottom: 1px solid ${colorsCP["neutral-30"]};
  }

  &__item-head {
		font-family: ${fontsCP["font-secondary"]["font-family"]};
    font-weight: 500;
		color: ${colorsCP["neutral-70"]};
		padding: 0 0 24px;
  }

  &__arrow-holder {
		color: ${colorsCP["blue-40"]};
  }
}
`
